module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/utees-full-logo-01204d274cd841fe0c4e72dbf2d09a33.svg";